import { api } from "../index";

export const submitInquiryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    submitInquiry: builder.mutation({
      query: (data) => ({
        url: "/api/v1/public/subscription_plans/inquiry_contact",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useSubmitInquiryMutation } = submitInquiryApi;